<template>
  <div id="stamp" class="borda-redonda">
    <b-row>
      <b-col cols="12" class="m-0 mt-2 text-center exo-stamp">
        <p class="m-0">{{ profissional.nome }}</p>
      </b-col>
    </b-row>
    <b-row class="m-0">
      <b-col cols="12" class="p-0 text-center">
        <p class="m-0">{{ firstLine }}</p>
        <p class="m-0">{{ secondLine }}</p>
        <p class="m-0">{{ thirdLine }}</p>
      </b-col>
    </b-row>
    <b-img
      :src="preview == null ? require('/static/images/no-stamp.png') : preview"
      class="rounded-0 inFront"
      :style="{ left: posicao }"
      fluid
    />
  </div>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import Files from "@/http/files";

export default {
  name: "StampComponent",

  props: ["profissional", "posicao"],

  data() {
    return {
      preview: null,
      files: new Files(this.$http),
    };
  },

  watch: {
    profissional: function (newValue) {
      this.carregar(newValue);
    },
  },

  computed: {
    firstLine() {
      let first = this.profissional.descricao.split(",");
      return first[0];
    },
    secondLine() {
      let first = this.profissional.descricao.split(",");
      return first[1];
    },
    thirdLine() {
      let first = this.profissional.descricao.split(",");
      return first[2];
    },
  },

  methods: {
    carregar(profissional) {
      if (profissional.id != 0) {
        let filename = profissional.id + "";
        this.files
          .downloadStamp(filename)
          .then((image) => {
            const reader = new FileReader();
            const blob = new Blob([image]);
            reader.readAsDataURL(blob);
            reader.onload = (e) => {
              this.preview = e.target.result;
            };
          })
          .catch(() => (this.preview = null));
      }
    },
  },

  setup() {
    const store = useSgcqStore();
    const profissionalStore = useProfissionalStore();

    return {
      store,
      profissionalStore,
    };
  },
};
</script>

<style lang="scss" scoped>
.exo-stamp {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-size: 1.2rem;
  padding: 0;
}

.inFront {
  position: absolute;
  top: 1.5rem;
  max-width: 200px;
}

.borda-redonda {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding: 0.5rem;
  min-height: 8.8rem;
}
</style>
